// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"6ec14f6a","443":"03fcaa01"}[chunkId] + ".chunk.css";
};